
var PushJumpType = {

  'ORDER_TIP': 11, // 订单提示
  'ORDER_HANDLE': 12, // 订单处理页
  'ORDER_DETAIL': 17, // 订单详情

  'ORDERSERVICE_TIP': 21, // 服务单提示
  'ORDERSERVICE_HANDLE': 22, // 服务单处理
  'ORDERSERVICE_GRAPHANDLE': 23, // 服务单抢单
  'ORDERSERVICE_DETAIL': 27, // 订单详情页

  'ORDERTASK_TIP': 31, // 工单提示
  'ORDERTASK_HANDLE': 32, // 工单处理
  'ORDERTASK_SENDOFF': 33, // 工单寄送
  'ORDERTASK_FINISH': 34, // 工单完成
  'ORDERTASK_DETAIL': 37, // 工单详情页

  'ORDERBECHECK_TIP': 51, // 被审核提醒 详情页 拒绝或通过
  'ORDERCHECK_HANDLE': 55, // 待审核提醒 处理页

  'ORDERRTC_START': 61, // 开始视频
  'ORDERRTC_BUSY': 66, // 用户正忙
  'ORDERRTC_END': 67, // 结束视频

  'ORDER_DELAY': 80 // 订单延迟推送
};

export { PushJumpType };
